import { InputNumber, InputNumberProps as InputNumberPropsDS } from '@billy/design-system'

import { useLocale } from '../../hooks/useLocale'
import { isLanguage, Language } from '../../types/language'
import { LocaleIdentifier } from '../../types/localeIdentifier'
import { languageToLocale } from '../../utils/languageToLocale'

// make locale optional
export type InputNumberLocalizedProps = Omit<InputNumberPropsDS, 'locale'> & Partial<Pick<InputNumberPropsDS, 'locale'>>

export const InputNumberLocalized = (props: InputNumberLocalizedProps) => {
  const { locale: inputLocale } = props
  const { code } = useLocale()

  const language: Language = isLanguage(code) ? code : 'en'
  const locale: LocaleIdentifier | undefined = inputLocale || languageToLocale[language]

  return <InputNumber weight="medium" {...props} locale={locale} />
}
